import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const FloatingElements: React.FC = () => {
  const [elements, setElements] = useState<Array<{
    id: number;
    emoji: string;
    x: number;
    y: number;
    delay: number;
  }>>([]);

  useEffect(() => {
    const emojis = ['⭐', '💖', '🌈', '🦋', '🌸', '✨', '🎨', '🎵'];
    const newElements = emojis.map((emoji, index) => ({
      id: index,
      emoji,
      x: Math.random() * (window.innerWidth - 100),
      y: Math.random() * (window.innerHeight - 100),
      delay: index * 0.5
    }));
    setElements(newElements);
  }, []);

  const floatAnimation = {
    y: [0, -20, -10, -30, 0],
    x: [0, 10, -5, 15, 0],
    rotate: [0, 5, -5, 10, 0]
  };

  const floatTransition = {
    duration: 6,
    repeat: Infinity,
    repeatType: "reverse" as const
  };

  return (
    <div className="floating-elements">
      {elements.map((element) => (
        <motion.div
          key={element.id}
          className="float-item"
          style={{
            position: 'absolute',
            left: element.x,
            top: element.y,
            fontSize: '2rem',
            opacity: 0.8,
            pointerEvents: 'none',
            zIndex: 1
          }}
          animate={floatAnimation}
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 0.8, scale: 1 }}
          viewport={{ once: true }}
          transition={{
            ...floatTransition,
            delay: element.delay
          }}
        >
          {element.emoji}
        </motion.div>
      ))}
      
      {/* Additional random sparkles */}
      {[...Array(5)].map((_, i) => (
        <motion.div
          key={`sparkle-${i}`}
          style={{
            position: 'absolute',
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            fontSize: '1rem',
            pointerEvents: 'none',
            zIndex: 1
          }}
          animate={{
            scale: [0, 1, 0],
            rotate: [0, 180, 360],
            opacity: [0, 0.6, 0]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            delay: i * 2,
            repeatType: "reverse"
          }}
        >
          ✨
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingElements;
